import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';
import { apiRoutes } from './apiRoutes';

export const getRecommendedDepositAmount = () =>
  post(apiRoutes.userInfo)
    .then(camelizeKeys)
    .then(({ data, status }) => (status === 'success' ? data : {}));
